import {FC} from 'react';
import {FormProvider} from './ui/form-provider';
import {Editor} from './ui/editor';

export const DeviceTypeStepEditor: FC = () => {
  return (
    <FormProvider>
      <Editor />
    </FormProvider>
  );
};
